import {
  MONITORING_CUSTOMERS_API_URL,
  monitoringQueryKeys,
} from './monitoring.constants';
import { CustomerType } from './monitoring.types';
import { useApiQuery } from '../../hooks';

export function useSupportCenterCustomers(isLabIncluded = false) {
  return useApiQuery<Array<CustomerType>>(
    `${MONITORING_CUSTOMERS_API_URL}?include_lab=${isLabIncluded}`,
    isLabIncluded
      ? monitoringQueryKeys.customers.withLabs()
      : monitoringQueryKeys.customers.withoutLabs(),
    {
      staleTime: 0,
    }
  );
}
